import { BodyText } from '@calendly/ui/components/typography';
const gradientBadgeCss = "gpc1v1r";
export const GradientBadge = ({
  title
}) => <div className={gradientBadgeCss}>
    <BodyText weight="semibold">{title}</BodyText>
  </div>;

require("./GradientBadge.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GradientBadge.js");